import {
  isAiMessage,
  isUserMessage,
  type ChatMessage,
} from '../../types/chatMessage';

export type TrainingPairDraft = {
  question: string;
  answer: string;
};

export function resolveTrainingPairFromMessage(
  messages: ChatMessage[],
  messageId: string,
): TrainingPairDraft {
  const index = messages.findIndex((message) => message.id === messageId);
  if (index === -1) {
    return { question: '', answer: '' };
  }

  const message = messages[index];

  if (isUserMessage(message)) {
    const question = message.content.trim();
    let answer = '';

    for (let cursor = index + 1; cursor < messages.length; cursor += 1) {
      const candidate = messages[cursor];
      if (isAiMessage(candidate)) {
        answer = candidate.content.trim();
        break;
      }
    }

    return { question, answer };
  }

  if (isAiMessage(message)) {
    const answer = message.content.trim();
    let question = '';

    for (let cursor = index - 1; cursor >= 0; cursor -= 1) {
      const candidate = messages[cursor];
      if (isUserMessage(candidate)) {
        question = candidate.content.trim();
        break;
      }
    }

    return { question, answer };
  }

  return { question: '', answer: '' };
}

export function canShowTrainingImproveAction(
  message: ChatMessage,
  canManageTraining: boolean,
): boolean {
  if (!canManageTraining) {
    return false;
  }

  if (message.isPendingAssistantReply === true) {
    return false;
  }

  return message.content.trim().length > 0;
}
